import { initReactI18next } from 'react-i18next';
import { use } from 'i18next';
import { Locale } from '@oneaudi/avp-hck-dga-customerui-commons';
import en from './en/translation.json';
/* eslint-disable camelcase */
import de_DE from './de_DE/translation.json';
import es_ES from './es_ES/translation.json';
import en_GB from './en_GB/translation.json';
import es_MX from './es_MX/translation.json';

export const getI18nLocale = (locale: Locale): Locale => {
  if (!locale) {
    return Locale.en;
  }
  const i18nLocale = (locale as string).replace('_', '-');

  return toLocaleOrEn(i18nLocale);
};

export const toLocaleOrEn = (locale: string): Locale => {
  return Object.keys(resources).includes(locale) ? (locale as Locale) : Locale.en;
};

const resources = {
  en: {
    translation: en,
  },
  'en-GB': {
    translation: en_GB,
  },
  'de-DE': {
    translation: de_DE,
  },
  'es-ES': {
    translation: es_ES,
  },
  'es-MX': {
    translation: es_MX,
  },
};

use(initReactI18next).init({
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  resources,
});
